<template>
  <div class="vg_wrapper vd_top" v-loading="loadingFlag">
    <div class="vd_edhea">
      <editHeader
        :isShow="isShow"
        :btn="btn"
        :strForm="podrForm"
        @openEdit="openEdit"
        @closeEdit="closeEdit"
        @submit="submit('podrForm')"
      />
      <el-button
        type="primary"
        size="small"
        class="vd_export"
        @click="buttonRefresh()"
        v-if="isShow"
        >刷新</el-button
      >
      <!-- <el-button type="primary" :disabled="isDisable" size="small" class="vd_exports" @click="takee()" v-if="isShow">生成产品信息</el-button> -->
    </div>
    <el-form
      ref="podrForm"
      :model="podrForm"
      label-width="120px"
      size="mini"
      :disabled="isShow"
      :rules="rules"
    >
      <el-row>
        <el-col :md="8">
          <el-form-item label="产品图片">
            <el-upload
              disabled
              class="avatar-uploader"
              :action="uploadUrl"
              :data="dataBody"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <!-- <img v-if="podrForm.imge_id" :src="podrForm.imge_url" class="avatar"/> -->
              <imgPopover
                v-if="podrForm.imge_id"
                :imgeUrl="podrForm.imge_url"
                :imgeUrlO="podrForm.imge_urlO"
              ></imgPopover>
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                :class="{ vd_cussor: isShow }"
              ></i>
            </el-upload>
            <!-- <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span> -->
          </el-form-item>
        </el-col>
        <el-col :md="16">
          <el-row>
            <el-col :md="12">
              <el-form-item label="产品编号" prop="prod_no">
                <el-input
                  disabled
                  v-model="podrForm.prod_no"
                  @input="podrForm.prod_no = helper.keepEngNum2(podrForm.prod_no)"
                  maxlength="10"
                  show-word-limit
                  placeholder="请填写产品编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="产品订单编号" prop="podr_no">
                <el-input
                  disabled
                  v-model="podrForm.podr_no"
                  @input="podrForm.podr_no = helper.keepEngNum2(podrForm.podr_no)"
                  maxlength="10"
                  show-word-limit
                  placeholder="请填写产品订单编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="16">
          <el-row>
            <el-col :md="12">
              <el-form-item label="产品名称" prop="prod_name">
                <el-input
                  :disabled="!specialDataFlag"
                  v-model="podrForm.prod_name"
                  maxlength="30"
                  show-word-limit
                  placeholder="请填写产品名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="产品数量" prop="podr_prod_num">
                <el-input
                  disabled
                  v-model="podrForm.podr_prod_num"
                  maxlength="10"
                  show-word-limit
                  placeholder="请填写产品订单编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="16">
          <el-row>
            <el-col :md="12">
              <el-form-item label="客户货号" prop="podr_prod_cust_no">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.podr_prod_cust_no"
                  @input="
                    podrForm.podr_prod_cust_no = helper.keepEngNum2(
                      podrForm.podr_prod_cust_no
                    )
                  "
                  show-word-limit
                  maxlength="30"
                  placeholder="请填写客户货号"
                >
                  <!-- <el-link slot="append" type="primary" @click="notice = true;" :disabled="isShow">导入</el-link> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="产品尺寸" prop="prod_spec">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.prod_spec"
                  maxlength="30"
                  show-word-limit
                  placeholder="请填写产品尺寸"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <!-- </el-row>
      <el-row> -->
        <!-- <el-col :md="8">
          <el-form-item label="打样数量" prop="prod_num" required>
            <el-input
              v-model="podrForm.prod_num"
              maxlength="10"
              @input="podrForm.prod_num = helper.keepTNum1(podrForm.prod_num)"
              show-word-limit
              placeholder="请填写打样数量"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :md="8">
          <el-form-item label="开版师" prop="prod_stff_id">
            <el-select
              v-model="podrForm.prod_stff_id"
              placeholder="请选择开版师"
              clearable
            >
              <el-option
                v-for="item in stffType"
                :key="item.stff_id"
                :label="item.stff_name"
                :value="item.stff_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :md="8">
          <el-form-item label="产品间报价" prop="prod_price">
            <el-input
              v-model="podrForm.prod_price"
              @input="
                podrForm.prod_price = helper.keepTNum1(podrForm.prod_price)
              "
              @blur="
                podrForm.prod_price = helper.calcPrice(
                  podrForm.prod_price,
                  4,
                  1000000
                )
              "
              maxlength="11"
              show-word-limit
              placeholder="请填写产品间报价"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <!-- </el-row>
      <el-row> -->
        <!-- <el-col :md="8">
          <el-form-item label="实际交样日期" prop="prod_deil_time">
            <el-date-picker
              v-model="podrForm.prod_deil_time"
              type="date"
              placeholder="选择交样日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="产品类型" prop="prod_type">
            <el-select
              v-model="podrForm.prod_type"
              placeholder="请选择产品类型"
              clearable
            >
              <el-option
                v-for="item in prodType"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="采购部核价" prop="prod_verify_price">
            <el-input
              v-model="podrForm.prod_verify_price"
              @input="
                podrForm.prod_verify_price = helper.keepTNum1(
                  podrForm.prod_verify_price
                )
              "
              @blur="
                podrForm.prod_verify_price = helper.calcPrice(
                  podrForm.prod_verify_price,
                  4,
                  1000000
                )
              "
              maxlength="11"
              show-word-limit
              placeholder="请填写采购部核价"
            ></el-input>
          </el-form-item>
        </el-col> -->
        
      <!-- </el-row>
      <el-row> -->
        <el-col :md="16">
          <el-row>
            <el-col :md="12">
              <el-form-item label="纸箱长度" prop="podr_prod_box_l">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.podr_prod_box_l"
                  @input="
                    podrForm.podr_prod_box_l = helper.keepTNum1(podrForm.podr_prod_box_l)
                  "
                  @blur="
                    podrForm.podr_prod_box_l = helper.retain1(
                      podrForm.podr_prod_box_l,
                      2,
                      1000000
                    )
                  "
                  maxlength="9"
                  show-word-limit
                  placeholder="请填写纸箱长度"
                >
                  <template slot="append">厘米</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="纸箱宽度" prop="podr_prod_box_w">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.podr_prod_box_w"
                  @input="
                    podrForm.podr_prod_box_w = helper.keepTNum1(podrForm.podr_prod_box_w)
                  "
                  @blur="
                    podrForm.podr_prod_box_w = helper.retain1(
                      podrForm.podr_prod_box_w,
                      2,
                      1000000
                    )
                  "
                  maxlength="9"
                  show-word-limit
                  placeholder="请填写纸箱宽度"
                >
                  <template slot="append">厘米</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="16">
          <el-row>
          <el-col :md="12">
            <el-form-item label="纸箱高度" prop="podr_prod_box_h">
              <el-input
              :disabled="!specialDataFlag"
                v-model="podrForm.podr_prod_box_h"
                @input="
                  podrForm.podr_prod_box_h = helper.keepTNum1(podrForm.podr_prod_box_h)
                "
                @blur="
                  podrForm.podr_prod_box_h = helper.retain1(
                    podrForm.podr_prod_box_h,
                    2,
                    1000000
                  )
                "
                maxlength="9"
                show-word-limit
                placeholder="请填写纸箱高度"
              >
                <template slot="append">厘米</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="塑料袋长度" prop="podr_prod_bag_l">
              <el-input
              :disabled="!specialDataFlag"
                v-model="podrForm.podr_prod_bag_l"
                @input="
                  podrForm.podr_prod_bag_l = helper.keepTNum1(podrForm.podr_prod_bag_l)
                "
                @blur="
                  podrForm.podr_prod_bag_l = helper.retain1(
                    podrForm.podr_prod_bag_l,
                    2,
                    1000000
                  )
                "
                maxlength="9"
                show-word-limit
                placeholder="请填写塑料袋长度"
              >
                <template slot="append">厘米</template>
              </el-input>
            </el-form-item>
          </el-col>
          </el-row>
        </el-col>
        <el-col :md="24">
          <el-row>
            <el-col :md="8">
              <div style="visibility: hidden;">11</div>
            </el-col>
            <el-col :md="8">
              <el-form-item label="塑料袋宽度" prop="podr_prod_bag_w">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.podr_prod_bag_w"
                  @input="
                    podrForm.podr_prod_bag_w = helper.keepTNum1(podrForm.podr_prod_bag_w)
                  "
                  @blur="
                    podrForm.podr_prod_bag_w = helper.retain1(
                      podrForm.podr_prod_bag_w,
                      2,
                      1000000
                    )
                  "
                  maxlength="9"
                  show-word-limit
                  placeholder="请填写塑料袋宽度"
                >
                  <template slot="append">厘米</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="装箱数" prop="prod_qpc">
                <el-input
                :disabled="!specialDataFlag"
                  v-model="podrForm.prod_qpc"
                  @input="podrForm.prod_qpc = helper.keepTNum(podrForm.prod_qpc)"
                  maxlength="10"
                  show-word-limit
                  placeholder="请填写装箱数"
                >
                  <template slot="append">箱</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
      </el-col>
      <el-col :md="16">
        <el-row>
          
          <!-- <el-col :md="8">
            <el-form-item label="最小起订量" prop="prod_moq">
              <el-input
                v-model="podrForm.prod_moq"
                @input="podrForm.prod_moq = helper.keepTNum1(podrForm.prod_moq)"
                maxlength="9"
                show-word-limit
                placeholder="请填写最小起订量"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :md="8">
            <el-form-item label="运费单价" prop="prod_freight">
              <el-input
                v-model="podrForm.prod_freight"
                @input="
                  podrForm.prod_freight = helper.keepTNum1(podrForm.prod_freight)
                "
                @blur="
                  podrForm.prod_freight = helper.calcPrice(
                    podrForm.prod_freight,
                    4,
                    1000000
                  )
                "
                maxlength="11"
                show-word-limit
                placeholder="请填写运费单价"
              ></el-input>
            </el-form-item>
          </el-col> -->
        <!-- </el-row>
        <el-row> -->
        </el-row>
      </el-col>
    </el-row>
      <!-- <el-col :md="16"> -->
    <el-row>
      <el-col :md="8">
        <div style="visibility: hidden;">11</div>
      </el-col>
      <el-col :md="8">
        <el-form-item label="装袋数" prop="podr_prod_qpc">
          <el-input
          :disabled="!specialDataFlag"
            v-model="podrForm.podr_prod_qpc"
            @input="podrForm.podr_prod_qpc = helper.keepTNum(podrForm.podr_prod_qpc)"
            maxlength="9"
            show-word-limit
            placeholder="请填写装袋数"
          >
            <template slot="append">个</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :md="8">
        <el-form-item label="产品重量" prop="podr_prod_weight">
          <el-input
          :disabled="!specialDataFlag"
            v-model="podrForm.podr_prod_weight"
            @input="
              podrForm.podr_prod_weight = helper.keepTNum1(podrForm.podr_prod_weight)
            "
            @blur="
              podrForm.podr_prod_weight = helper.retain1(
                podrForm.podr_prod_weight,
                2,
                1000000
              )
            "
            maxlength="9"
            show-word-limit
            placeholder="请填写产品重量"
          >
            <template slot="append">克</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="8">
        <div style="visibility: hidden;">11</div>
      </el-col>
      <el-col :md="8">
        <el-form-item label="皮克重量" prop="podr_prod_skin_weight">
          <el-input
          :disabled="!specialDataFlag"
            v-model="podrForm.podr_prod_skin_weight"
            @input="
              podrForm.podr_prod_skin_weight = helper.keepTNum1(
                podrForm.podr_prod_skin_weight
              )
            "
            @blur="
              podrForm.podr_prod_skin_weight = helper.retain1(
                podrForm.podr_prod_skin_weight,
                2,
                1000000
              )
            "
            maxlength="9"
            show-word-limit
            placeholder="请填写皮克重量"
          >
            <template slot="append">克</template>
          </el-input>
        </el-form-item>
      </el-col>
    <!-- </el-row>
    <el-row> -->
      <el-col :md="8">
        <el-form-item label="填充物重量" prop="podr_prod_fill_weight">
          <el-input
          :disabled="!specialDataFlag"
            v-model="podrForm.podr_prod_fill_weight"
            @input="
              podrForm.podr_prod_fill_weight = helper.keepTNum1(
                podrForm.podr_prod_fill_weight
              )
            "
            @blur="
              podrForm.podr_prod_fill_weight = helper.retain1(
                podrForm.podr_prod_fill_weight,
                2,
                1000000
              )
            "
            maxlength="9"
            show-word-limit
            placeholder="请填写填充物重量"
          >
            <template slot="append">克</template>
          </el-input>
        </el-form-item>
      </el-col>
      <!-- </el-row> -->
    <!-- </el-col> -->
      <!-- <el-row> -->
    </el-row>
      <!-- <el-row class="vd_buttom">
        <el-col :md="8">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="podrForm.remark"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-tabs v-model="activeName" class="vd_eltab vd_buttom" :disabled="true">
        <el-tab-pane label="BOM清单" name="first" :key="'first'">
          <div class="vd_but">
            <!-- <el-button type="primary" plain size="small" @click="addRow()"
              >导入</el-button
            >
            <el-button type="danger" plain size="small" @click="delBom()"
              >删除</el-button
            > -->
          </div>
          <ProdEditBomChild
            :specialDataFlag="!specialDataFlag"
            :isShow="showBom"
            :mtrlTypeGroupOpt="mtrlTypeGroupOpt"
            :podrForm="podrForm"
            @handleSelectionChange="handleSelectionChange"
            v-loading="bomFlag"
          ></ProdEditBomChild>
        </el-tab-pane>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="70%">
          <ProdEditBom
            @falseBom="falseBom"
            @childBom="childBom"
            @bomChildChanel="bomChildChanel"
            ref="ProdEditBom"
          ></ProdEditBom>
        </el-dialog>
        <el-tab-pane label="加工面料" name="second" :key="'second'">
          <div class="vd_but">
            <el-button type="primary" plain size="small" @click="addPlmtrl()"
              >添加</el-button
            >
            <!-- <el-button type="success" plain size="small" @click="importPlmtrl()">导入</el-button> -->
            <el-button type="danger" plain size="small" @click="delPlmtrl()"
              >删除</el-button
            >
          </div>
          <ProdEditPlmtrlChild
            @compListChange="compListChange"
            v-if="showPlmtrl"
            :isShow="isShow"
            :plmtrlShow="plmtrlShow"
            @plmtrlChangeCut="plmtrlChangeCut"
            @plmtrlChangeIds="plmtrlChangeIds"
            @deletePlmtrl="deletePlmtrl"
            :mtrlTypeGroupOpt="mtrlTypeGroupOpt"
            :podrForm="podrForm"
            @handleSelectionChange2="handleSelectionChange2"
            v-loading="plmtrlFlag"
          ></ProdEditPlmtrlChild>
        </el-tab-pane>
        <el-dialog :title="title1" :visible.sync="dialogVisible1" width="70%">
          <ProdEditPlmtrl
            @childPlmtrl="childPlmtrl"
            @plmtrlChildChanel="plmtrlChildChanel"
            ref="ProdEditBom"
          ></ProdEditPlmtrl>
        </el-dialog>
        <el-tab-pane label="裁片信息" name="third" :key="'third'">
          <div class="vd_but">
            <el-button type="primary" plain size="small" @click="addCut()"
              >添加</el-button
            >
            <el-button type="danger" plain size="small" @click="delCut()"
              >删除</el-button
            >
          </div>
          <ProdEditCutChild
            @cutChangeCuts="cutChangeCuts"
            @cutChangeIds="cutChangeIds"
            :podrForm="podrForm"
            @handleSelectionChange1="handleSelectionChange1"
            v-loading="cutFlag"
          ></ProdEditCutChild>
        </el-tab-pane>
        <el-tab-pane label="在制品信息" name="fourth" :key="'fourth'">
          <div class="vd_but">
            <el-button type="primary" plain size="small" @click="addSemiprod()"
              >添加</el-button
            >
            <el-button type="danger" plain size="small" @click="delSemiprod()"
              >删除</el-button
            >
          </div>
          <ProdEditSemiprodChild
            v-if="showSemiprod"
            @semiprodChangeCut="semiprodChangeCut"
            @semiprodChangeIds="semiprodChangeIds"
            :podrForm="podrForm"
            @handleSelectChangeSemiprod="handleSelectChangeSemiprod"
            v-loading="semiprodFlag"
          ></ProdEditSemiprodChild>
        </el-tab-pane>
      </el-tabs>
      <el-row class="vg_mt_16 vd_bortop">
        <el-col>
          <inputUser
            :isCookie="false"
            :stffForm="stffForm"
            ref="userData"
            v-if="podrForm.stff_name"
          ></inputUser>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { get, post } from "@api/request";
import { podtAPI } from "@api/modules/podt";
import { stffAPI } from "@api/modules/staff";
import { optnAPI } from "@api/modules/optn";
import { imgeAPI } from "@api/modules/imge";
import editHeader from "@/views/component/editHeader";
import inputUser from "@/views/component/inputUser";
import helper from "@assets/js/helper";
import ProdEditBom from "@/views/ProduceManagement/PodtManage/TabChild/Componet/PodtEditBom";
import ProdEditPlmtrl from "@/views/ProduceManagement/PodtManage/TabChild/Componet/PodtEditPlmtrl";
import ProdEditBomChild from "@/views/ProduceManagement/PodtManage/TabChild/Componet/TabPanel/PodtEditBomChild";
import ProdEditPlmtrlChild from "@/views/ProduceManagement/PodtManage/TabChild/Componet/TabPanel/PodtEditPlmtrlChild";
import ProdEditCutChild from "@/views/ProduceManagement/PodtManage/TabChild/Componet/TabPanel/PodtEditCutChild";
import ProdEditSemiprodChild from "@/views/ProduceManagement/PodtManage/TabChild/Componet/TabPanel/PodtEditSemiprodChild";
import imgPopover from "@/views/component/imgPopover";

export default {
  name: "prodEditMain",
  components: {
    editHeader,
    inputUser,
    ProdEditBom,
    ProdEditBomChild,
    ProdEditPlmtrlChild,
    ProdEditCutChild,
    ProdEditPlmtrl,
    ProdEditSemiprodChild,
    imgPopover,
  },
  data() {
    return {
      podrForm: {},
      rules: {
        prod_no: [{ required: true, trigger: "blur", message: " " }],
        prod_name: [{ required: true, trigger: "blur", message: " " }],
        prod_type: [{ required: true, trigger: "change", message: " " }],
      },
      num: 0,
      prod_id: "",
      dialogVisible: false,
      dialogVisible1: false,
      activeName: "first",
      activeName2: "",
      isShow: true,
      btn: {},
      mtrlTypeGroupOpt: [],
      selectionsList: [],
      plmtrlSelect: [],
      cutSelect: [],
      semiprodSelect: [],
      bomCopy: [],
      plmtrlCopy: [],
      cutCopy: [],
      semiprodCopy: [],
      title: "物料总库存信息",
      title1: "加工面料",
      prodType: [
        { id: 1, label: "新款" },
        { id: 2, label: "老款" },
        { id: 3, label: "修改款" },
      ],
      stffType: [],
      bomProdMtrlId: -1,
      cutProdMtrlId: -1001,
      plmtrlProdMtrlId: -501,
      semiprodProdMtrlId: -1501,
      bomFlag: false,
      plmtrlFlag: false,
      cutFlag: false,
      semiprodFlag: false,
      plmtrlOption: [],
      cutOption: [],
      semiprodOption: [],
      stffForm: {
        stff_name: "",
        cptt_name: "",
        dept_name: "",
        dept_team_name: "",
        stff_id: Number,
        cptt_id: Number,
        dept_id: Number,
        dept_team_id: Number,
      },
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400,
      },
      showPlmtrl: true,
      showSemiprod: true,
      showBom: true,
      plmtrlShow:false,
      uploadUrl: helper.modePrepend(imgeAPI.uploadImage),
      show: false,
      imgForm: {
        imge_id: null,
        imge_url: null,
        imge_urlO: null,
      },
      loadingFlag: true,
      specialDataFlag:false,
    };
  },
  created() {
    this.initData();
  },
  watch: {},
  methods: {
    initData() {
      this.bomProdMtrlId = -1;
      this.cutProdMtrlId = -1001;
      this.plmtrlProdMtrlId = -501;
      this.semiprodProdMtrlId = -1501;
      this.plmtrlOption = [];
      this.cutOption = [];
      this.semiprodOption = [];
      this.loadingFlag = true;
      this.getprodInfo();
      this.getStffType();
      this.getMtrlType();
      if(this.$cookies.get('userInfo').acct_id === 1){
        this.specialDataFlag = true
      }
    },
    //启用编辑
    openEdit() {
      this.isShow = false;
      this.showBom = false;
      this.$emit("isShow", this.isShow);
    },
    //撤销编辑
    closeEdit() {
      if (this.num > 0) {
        return this.$message.warning("请先保存RFId卡信息");
      }
      this.$confirm("是否撤销编辑?", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          this.isShow = true;
          this.showBom = true;
          this.$emit("isShow", this.isShow);
          this.show = true;
          this.bomProdMtrlId = -1;
          this.cutProdMtrlId = -1001;
          this.plmtrlProdMtrlId = -501;
          this.semiprodProdMtrlId = -1501;
          this.plmtrlOption = [];
          this.cutOption = [];
          this.semiprodOption = [];
          this.$message({
            type: "info",
            message: "已撤销编辑!",
          });
          this.initData();
        })
        .catch(() => {});
    },
    //提交表单
    submit(formName) {
      if (this.num > 0) {
        return this.$message.warning("请先保存RFId卡信息");
      }
      this.$confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.saveInfo();
            } else {
              console.log("error submit!");
              return false;
            }
          });
        })
        .catch(() => {});
    },
    // 保存
    saveInfo() {
      let podrForm = {};
      podrForm = Object.assign(podrForm, this.podrForm);
      podrForm.prod_deil_time = parseInt(podrForm.prod_deil_time / 1000);
      this.bomCopy = this.bomCopy.filter((item) =>
        podrForm.podr_prod_mtrl_list.every(
          (item1) => item.podr_prod_mtrl_id !== item1.podr_prod_mtrl_id
        )
      );
      this.plmtrlCopy = this.plmtrlCopy.filter((item) =>
        podrForm.podr_prod_plmtrl_list.every(
          (item1) => item.podr_prod_mtrl_id !== item1.podr_prod_mtrl_id
        )
      );
      this.cutCopy = this.cutCopy.filter((item) =>
        podrForm.podr_prod_cut_list.every(
          (item1) => item.podr_prod_mtrl_id !== item1.podr_prod_mtrl_id
        )
      );
      this.semiprodCopy = this.semiprodCopy.filter((item) =>
        podrForm.podr_prod_semiprod_list.every(
          (item1) => item.podr_prod_mtrl_id !== item1.podr_prod_mtrl_id
        )
      );
      for (let i = 0; i < this.bomCopy.length; i++) {
        this.bomCopy[i].destroy_flag = 1;
      }
      for (let i = 0; i < this.plmtrlCopy.length; i++) {
        this.plmtrlCopy[i].destroy_flag = 1;
      }
      for (let i = 0; i < this.cutCopy.length; i++) {
        this.cutCopy[i].destroy_flag = 1;
      }
      for (let i = 0; i < this.semiprodCopy.length; i++) {
        this.semiprodCopy[i].destroy_flag = 1;
      }
      podrForm.podr_prod_mtrl_list = podrForm.podr_prod_mtrl_list.concat(this.bomCopy);
      podrForm.podr_prod_plmtrl_list = podrForm.podr_prod_plmtrl_list.concat(
        this.plmtrlCopy
      );
      podrForm.podr_prod_cut_list = podrForm.podr_prod_cut_list.concat(this.cutCopy);
      podrForm.podr_prod_semiprod_list = podrForm.podr_prod_semiprod_list.concat(
        this.semiprodCopy
      );
      for (let i = 0; i < podrForm.podr_prod_cut_list.length; i++) {
        podrForm.podr_prod_cut_list[i].mtrl_no =
          podrForm.prod_no + "@" + podrForm.podr_prod_cut_list[i].mtrl_no;
      }
      for (let i = 0; i < podrForm.podr_prod_semiprod_list.length; i++) {
        podrForm.podr_prod_semiprod_list[i].mtrl_no =
          podrForm.prod_no + "#" + podrForm.podr_prod_semiprod_list[i].mtrl_no;
      }
      let flag = podrForm.podr_prod_mtrl_list.some(item =>{
        return item.podr_prod_mtrl_len_wid ==''
      })
      if(flag){
        return this.$message.warning('剪料长宽不可为空')
      }
      post(podtAPI.editPodt, podrForm)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.isShow = true;
            this.showBom = true;
            this.bomProdMtrlId = -1;
            this.cutProdMtrlId = -1001;
            this.plmtrlProdMtrlId = -501;
            this.semiprodProdMtrlId = -1501;
            this.plmtrlOption = [];
            this.cutOption = [];
            this.semiprodOption = [];
            this.$emit("isShow", this.isShow);
            this.initData();
          } else if (res.data.code === 7) {
            this.$message({
              type: "error",
              message: "单据编号重复",
            });
          } else {
            let mg = res.data.msg;
            let tp = "error";
            this.$message({ message: mg, type: tp });
          }
        })
        .catch((res) => {
          let mg = res.data.msg;
          let tp = "error";
          this.$message({ message: mg, type: tp });
        });
    },
    // 刷新按钮
    buttonRefresh() {
      this.bomProdMtrlId = -1;
      this.cutProdMtrlId = -1001;
      this.plmtrlProdMtrlId = -501;
      this.semiprodProdMtrlId = -1501;
      this.plmtrlOption = [];
      this.cutOption = [];
      this.semiprodOption = [];
      this.initData();
    },
    // 添加图片
    // 成功上传
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        let updateTime = JSON.parse(JSON.stringify(new Date().getTime()))
        let urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.podrForm.imge_id = res.data.imge_id;
        this.podrForm.imge_url = this.helper.picUrl(urlEng, "s",updateTime,0);
        this.podrForm.imge_urlO = this.helper.picUrl(urlEng, "l",updateTime,0);
      } else {
        let mg = res.msg;
        let tp = "error";
        this.$message({ message: mg, type: tp });
      }
    },
    // 上传头像前
    beforeAvatarUpload() {},
    // 裁片选择框选中
    handleSelectChangeSemiprod(val) {
      this.semiprodSelect = [];
      this.semiprodSelect = val;
    },
    // 在制品新增
    addSemiprod() {
      if (
        (this.podrForm.podr_prod_semiprod_list.length > 0 &&
          this.podrForm.podr_prod_semiprod_list[
            this.podrForm.podr_prod_semiprod_list.length - 1
          ].mtrl_no) ||
        this.podrForm.podr_prod_semiprod_list.length === 0
      ) {
        this.semiprodFlag = true;
        setTimeout(() => {
          let item = {
            mtrl_no: null,
            mtrl_name: null,
            prod_parent_ids: null,
            podr_prod_mtrl_id: this.semiprodProdMtrlId,
            prod_parent_list: [],
            semiprodOption: JSON.parse(JSON.stringify(this.semiprodOption)),
          };
          this.podrForm.podr_prod_semiprod_list.push(item);
          this.semiprodProdMtrlId--;
          this.semiprodFlag = false;
        }, 500);
      } else {
        this.$message.warning("请把物料编号补充完整再进行添加");
      }
    },
    // 在制品删除
    delSemiprod() {
      if (this.semiprodSelect.length > 0) {
        this.semiprodFlag = true;
        this.bomFlag = true;
        this.plmtrlFlag = true;
        this.cutFlag = true;
        let temp = [];
        for (let i = 0; i < this.semiprodSelect.length; i++) {
          let ind = null;
          ind = this.podrForm.podr_prod_semiprod_list.indexOf(
            this.semiprodSelect[i]
          );
          temp.push(ind);
          for (let j = 0; j < this.podrForm.podr_prod_semiprod_list.length; j++) {
            for (
              let a = 0;
              a < this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.length;
              a++
            ) {
              if (
                Number(this.semiprodSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_semiprod_list[j].prod_parent_list[a]
              ) {
                this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.splice(
                  a,
                  1
                );
                break;
              }
            }
            for (
              let a = 0;
              a < this.podrForm.podr_prod_semiprod_list[j].semiprodOption.length;
              a++
            ) {
              if (
                Number(this.semiprodSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_semiprod_list[j].semiprodOption[a]
                  .podr_prod_mtrl_id
              ) {
                this.podrForm.podr_prod_semiprod_list[j].semiprodOption.splice(a, 1);
                break;
              }
            }
          }
          for (let j in this.semiprodOption) {
            if (
              Number(this.semiprodSelect[i].podr_prod_mtrl_id) ===
              this.semiprodOption[j].podr_prod_mtrl_id
            ) {
              this.semiprodOption.splice(j, 1);
              break;
            }
          }
        }
        for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
          if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 0
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids = "";
          } else if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 1
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[
                i
              ].prod_parent_list[0].toString();
          } else {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.split(",");
          }
        }
        temp = temp.sort((a, b) => {
          return b - a;
        });
        for (let j of temp) {
          this.podrForm.podr_prod_semiprod_list.splice(j, 1);
        }
        setTimeout(() => {
          this.bomFlag = false;
          this.plmtrlFlag = false;
          this.cutFlag = false;
          this.semiprodFlag = false;
        }, 500);
      } else {
        this.$message({
          message: "至少选择一条信息",
          type: "warning",
        });
      }
    },
    // 在制品回显使用物料
    semiprodChangeIds(val) {
      this.showSemiprod = false;
      this.podrForm.podr_prod_semiprod_list[val.$index].prod_parent_ids =
        val.row.prod_parent_list.join(",");
      this.$nextTick(() => {
        this.showSemiprod = true;
      });
    },
    //在制品填写编号时修改在制品的一些选项值
    semiprodChangeCut(scope) {
      if (scope.row.mtrl_no.indexOf(" ") === -1) {
        let semiprodTemp = -1;
        let temp = {};
        temp.podr_prod_mtrl_id = scope.row.podr_prod_mtrl_id;
        temp.mtrl_no = this.podrForm.prod_no + "#" + scope.row.mtrl_no;
        for (let i = 0; i < this.semiprodOption.length; i++) {
          if (this.semiprodOption[i].podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id) {
            semiprodTemp = i;
          }
        }
        if (semiprodTemp !== -1) {
          this.semiprodOption[semiprodTemp].mtrl_no = scope.row.mtrl_no;
        } else {
          this.semiprodOption.push(temp);
        }
        for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
          for (
            let j = 0;
            j < this.podrForm.podr_prod_semiprod_list[i].semiprodOption.length;
            j++
          ) {
            if (
              this.podrForm.podr_prod_semiprod_list[i].semiprodOption[j]
                .podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id
            ) {
              this.podrForm.podr_prod_semiprod_list[i].semiprodOption[j].mtrl_no =
                this.podrForm.prod_no + "#" + scope.row.mtrl_no;
            }
          }
        }
      }
    },
    // 裁片选择框选中
    handleSelectionChange1(val) {
      this.cutSelect = [];
      this.cutSelect = val;
    },
    //在制品填写编号时修改在制品的一些选项值
    cutChangeCuts(scope) {
      if (scope.row.mtrl_no.indexOf(" ") === -1) {
        let semiprodTemp = -1;
        let temp = {};
        temp.podr_prod_mtrl_id = scope.row.podr_prod_mtrl_id;
        temp.mtrl_no = this.podrForm.prod_no + "@" + scope.row.mtrl_no;
        for (let i = 0; i < this.semiprodOption.length; i++) {
          if (this.semiprodOption[i].podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id) {
            semiprodTemp = i;
          }
        }
        if (semiprodTemp !== -1) {
          this.semiprodOption[semiprodTemp].mtrl_no = temp.mtrl_no;
        } else {
          this.semiprodOption.push(temp);
        }
        for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
          this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(JSON.stringify(this.semiprodOption))
        //   for (
        //     let j = 0;
        //     j < this.podrForm.podr_prod_semiprod_list[i].semiprodOption.length;
        //     j++
        //   ) {
        //     if (
        //       this.podrForm.podr_prod_semiprod_list[i].semiprodOption[j]
        //         .podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id
        //     ) {
        //       this.podrForm.podr_prod_semiprod_list[i].semiprodOption[j].mtrl_no =
        //         this.podrForm.prod_no + "@" + scope.row.mtrl_no;
        //     }
        //   }
        }
      }
    },
    // 裁片新增
    addCut() {
      this.cutFlag = true
      let item = {
        mtrl_no: null,
        mtrl_name: null,
        prod_parent_ids: null,
        podr_prod_mtrl_id: this.cutProdMtrlId,
        prod_parent_value: null,
        cutOption: JSON.parse(JSON.stringify(this.cutOption)),
      };
      this.podrForm.podr_prod_cut_list.push(item);
      this.cutProdMtrlId--;
      setTimeout(() => {
        this.cutFlag = false;
      }, 500);
    },
    // 裁片回显使用物料
    cutChangeIds(val) {
      this.podrForm.podr_prod_cut_list[val.$index].prod_parent_ids =
        val.row.prod_parent_value.toString();
    },
    // 裁片删除
    delCut() {
      if (this.cutSelect.length > 0) {
        this.bomFlag = true;
        this.plmtrlFlag = true;
        this.cutFlag = true;
        this.semiprodFlag = true;
        this.showSemiprod = false;
        let temp = [];
        for (let i = 0; i < this.cutSelect.length; i++) {
          let ind = null;
          ind = this.podrForm.podr_prod_cut_list.indexOf(this.cutSelect[i]);
          temp.push(ind);
          for (let j = 0; j < this.podrForm.podr_prod_semiprod_list.length; j++) {
            for (
              let a = 0;
              a < this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.length;
              a++
            ) {
              if (
                Number(this.cutSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_semiprod_list[j].prod_parent_list[a]
              ) {
                this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.splice(
                  a,
                  1
                );
                break;
              }
            }
            for (
              let a = 0;
              a < this.podrForm.podr_prod_semiprod_list[j].semiprodOption.length;
              a++
            ) {
              if (
                Number(this.cutSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_semiprod_list[j].semiprodOption[a]
                  .podr_prod_mtrl_id
              ) {
                this.podrForm.podr_prod_semiprod_list[j].semiprodOption.splice(a, 1);
                break;
              }
            }
          }
          for (let j in this.semiprodOption) {
            if (
              Number(this.cutSelect[i].podr_prod_mtrl_id) ===
              this.semiprodOption[j].podr_prod_mtrl_id
            ) {
              this.semiprodOption.splice(j, 1);
              break;
            }
          }
        }
        for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
          // this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(JSON.stringify(this.semiprodOption))
          if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 0
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids = "";
          } else if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 1
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[
                i
              ].prod_parent_list[0].toString();
          } else {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.split(",");
          }
        }
        temp = temp.sort((a, b) => {
          return b - a;
        });
        for (let j of temp) {
          this.podrForm.podr_prod_cut_list.splice(j, 1);
        }
        setTimeout(() => {
          this.bomFlag = false;
          this.plmtrlFlag = false;
          this.cutFlag = false;
          this.semiprodFlag = false;
          this.showSemiprod = true;
        }, 500);
      } else {
        this.$message({
          message: "至少选择一条信息",
          type: "warning",
        });
      }
    },
    // 加工面料导入打开物料选择
    importPlmtrl() {
      this.dialogVisible1 = true;
    },
    //新增数据填写编号时修改裁片的值
    plmtrlChangeCut(scope) {
      console.log('val',scope);
      if (scope.row.mtrl_no.indexOf(" ") === -1) {
        this.showPlmtrl = false;
        let plmtrlTemp = -1;
        let cutTemp = -1;
        let temp = {};
        temp.podr_prod_mtrl_id = scope.row.podr_prod_mtrl_id;
        temp.mtrl_no = scope.row.mtrl_no;
        for (let i = 0; i < this.cutOption.length; i++) {
          if (this.cutOption[i].podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id) {
            cutTemp = i;
          }
        }
        for (let i = 0; i < this.plmtrlOption.length; i++) {
          if (this.plmtrlOption[i].podr_prod_mtrl_id === scope.row.podr_prod_mtrl_id) {
            plmtrlTemp = i;
          }
        }
        if (cutTemp !== -1) {
          this.cutOption[cutTemp].mtrl_no = scope.row.mtrl_no;
        } else {
          this.cutOption.push(temp);
        }
        if (plmtrlTemp !== -1) {
          this.plmtrlOption[plmtrlTemp].mtrl_no = scope.row.mtrl_no;
        } else {
          this.plmtrlOption.push(temp);
        }
        for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
          this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
            JSON.stringify(this.cutOption)
          );
        }
        for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
          for (
            let j = 0;
            j < this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption.length;
            j++
          ) {
            if (
              this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption[j].podr_prod_mtrl_id ===
              scope.row.podr_prod_mtrl_id
            ) {
              this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption[j].mtrl_no =
                scope.row.mtrl_no;
            }
            }
          for (
              let j = 0;
              j < this.podrForm.podr_prod_plmtrl_list[i].prod_parent_listO.length;
              j++
            ) {
              if (
                this.podrForm.podr_prod_plmtrl_list[i].prod_parent_listO[j].podr_prod_mtrl_id ===
                scope.row.podr_prod_mtrl_id
              ) {
                this.podrForm.podr_prod_plmtrl_list[i].prod_parent_listO[j].mtrl_no =
                  scope.row.mtrl_no;
            }
          }
        }
        this.$nextTick(() => {
          this.showPlmtrl = true;
        });
      }
    },
    compListChange(val, num) {
      if(this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no){
        this.showPlmtrl = false;
        if (num === 0) {
          if (this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no.length < 29) {
            this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no =
              this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no + "-F";
          }
        } else if (num === 1) {
          if (this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no.length < 29) {
            this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no =
              this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no + "-Y";
          }
        } else if (num === 2) {
          if (this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no.length < 29) {
            this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no =
              this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no + "-D";
          }
        }
        let plmtrlTemp = -1;
        let cutTemp = -1;
        let temp = {};
        temp.podr_prod_mtrl_id = val.row.podr_prod_mtrl_id;
        temp.mtrl_no = this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no;
        for (let i = 0; i < this.cutOption.length; i++) {
          if (this.cutOption[i].podr_prod_mtrl_id === val.row.podr_prod_mtrl_id) {
            cutTemp = i;
          }
        }
        for (let i = 0; i < this.plmtrlOption.length; i++) {
          if (this.plmtrlOption[i].podr_prod_mtrl_id === val.row.podr_prod_mtrl_id) {
            plmtrlTemp = i;
          }
        }
        if (cutTemp !== -1) {
          this.cutOption[cutTemp].mtrl_no =
            this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no;
        } else {
          this.cutOption.push(temp);
        }
        if (plmtrlTemp !== -1) {
          this.plmtrlOption[plmtrlTemp].mtrl_no =
            this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no;
        } else {
          this.plmtrlOption.push(temp);
        }
        for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
          this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
            JSON.stringify(this.cutOption)
          );
        }
        for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
          for (
            let j = 0;
            j < this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption.length;
            j++
          ) {
            if (
              this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption[j].podr_prod_mtrl_id ===
              val.row.podr_prod_mtrl_id
            ) {
              this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption[j].mtrl_no =
                this.podrForm.podr_prod_plmtrl_list[val.$index].mtrl_no;
            }
          }
        }
        this.$nextTick(() => {
          this.showPlmtrl = true;
        });
      }
      // else{
      //   setTimeout(() => {
      //     if(this.plmtrlShow){
      //       this.plmtrlShow = false
      //       return 
      //     }
      //     this.$message.warning('请填写物料编号')
      //   }, 100);
      // }
    },
    // plmtrlShowChange变化
    // plmtrlShowChange(){
    //   this.plmtrlShow = true
    // },
    // 加工面料小窗口确定
    childPlmtrl(val) {
      let plmtrlImportVal = val;
      plmtrlImportVal = plmtrlImportVal.filter((item) =>
        this.podrForm.podr_prod_plmtrl_list.every(
          (item1) => item.mtrl_id !== item1.mtrl_id
        )
      );
      for (let i of plmtrlImportVal) {
        i.podr_prod_mtrl_id = this.plmtrlProdMtrlId;
        i.plmtrlOption = JSON.parse(JSON.stringify(this.plmtrlOption));
        this.plmtrlProdMtrlId--;
      }
      for (let i = 0; i < plmtrlImportVal.length; i++) {
        let item = {};
        item.podr_prod_mtrl_id = plmtrlImportVal[i].podr_prod_mtrl_id;
        item.mtrl_no = plmtrlImportVal[i].mtrl_no;
        this.cutOption.push(item);
        this.plmtrlOption.push(item);
      }
      for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
        this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
          JSON.stringify(this.cutOption)
        );
      }
      this.podrForm.podr_prod_plmtrl_list =
        this.podrForm.podr_prod_plmtrl_list.concat(plmtrlImportVal);
      this.$refs.ProdEditBom.clear();
      this.dialogVisible1 = false;
    },
    // 加工面料小窗口取消
    plmtrlChildChanel() {
      this.dialogVisible1 = false;
    },
    // 加工面料选择框选中
    handleSelectionChange2(val) {
      this.plmtrlSelect = [];
      this.plmtrlSelect = val;
    },
    // 加工面料删除回显物料
    deletePlmtrl(scope,val){
      this.showPlmtrl = false;
      let temp = JSON.parse(JSON.stringify(val));
      let ind = null
      for(let i=0;i<this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.length;i++){
        this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO[i].key = i;
        if(this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO[i].podr_prod_mtrl_id === temp.podr_prod_mtrl_id){
          ind = i
        }
      }
      if(this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.indexOf(temp.podr_prod_mtrl_id) !== -1){
        this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.splice(this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.indexOf(temp.podr_prod_mtrl_id),1)
        this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_ids = this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.join(",");
      }
      this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.splice(ind,1)
      if(this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.length>0){
        this.podrForm.podr_prod_plmtrl_list[scope.$index].mtrl_no = this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO[0].mtrl_no
      }else{
        this.podrForm.podr_prod_plmtrl_list[scope.$index].mtrl_no = ''
      }
      this.$nextTick(() => {
        this.showPlmtrl = true;
      });
    },
    // 加工面料回显使用物料
    plmtrlChangeIds(scope,val) {
      this.showPlmtrl = false;
      for(let i=0;i<this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.length;i++){
        this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO[i].key = i;
      }
      let temp = JSON.parse(JSON.stringify(val));
      temp.key = this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.length;
      this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO.push(JSON.parse(JSON.stringify(temp)))
      this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.push(JSON.parse(JSON.stringify(Number(temp.podr_prod_mtrl_id))))
      this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_ids = this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_list.join(",");
      this.podrForm.podr_prod_plmtrl_list[scope.$index].mtrl_no = this.podrForm.podr_prod_plmtrl_list[scope.$index].prod_parent_listO[0].mtrl_no;
      this.$nextTick(() => {
        this.showPlmtrl = true;
      });
    },
    // 加工面料新增
    addPlmtrl() {
      if (
        (this.podrForm.podr_prod_plmtrl_list.length > 0 &&
          this.podrForm.podr_prod_plmtrl_list[
            this.podrForm.podr_prod_plmtrl_list.length - 1
          ].mtrl_no) ||
        this.podrForm.podr_prod_plmtrl_list.length === 0
      ) {
        this.plmtrlFlag = true;
        setTimeout(() => {
          let item = {
            mtrl_no: null,
            mtrl_name: null,
            mtrl_unit: null,
            mtrl_prod_price: "0.0000",
            prod_parent_ids: null,
            podr_prod_mtrl_id: this.plmtrlProdMtrlId,
            prod_parent_list: [],
            prod_parent_listO:[],
            plmtrlOption: JSON.parse(JSON.stringify(this.plmtrlOption)),
          };
          this.podrForm.podr_prod_plmtrl_list.push(item);
          this.plmtrlProdMtrlId--;
          this.plmtrlFlag = false;
        }, 500);
      } else {
        this.$message.warning("请把物料编号补充完整");
      }
    },
    // 加工面料删除
    delPlmtrl() {
      if (this.plmtrlSelect.length > 0) {
        this.bomFlag = true;
        this.plmtrlFlag = true;
        this.cutFlag = true;
        this.semiprodFlag = true;
        let temp = [];
        for (let i = 0; i < this.plmtrlSelect.length; i++) {
          let ind = null;
          ind = this.podrForm.podr_prod_plmtrl_list.indexOf(this.plmtrlSelect[i]);
          temp.push(ind);
          for (let j = 0; j < this.podrForm.podr_prod_plmtrl_list.length; j++) {
            for (
              let a = 0;
              a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list.length;
              a++
            ) {
              if (
                Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list[a]
              ) {
                this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list.splice(a, 1);
                break;
              }
            }
            for (
              let a = 0;
              a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.length;
              a++
            ) {
              if (
                Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO[a].podr_prod_mtrl_id
              ) {
                this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.splice(a, 1);
                break;
              }
            }
            for (
              let a = 0;
              a < this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption.length;
              a++
            ) {
              if (
                Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption[a].podr_prod_mtrl_id
              ) {
                this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption.splice(a, 1);
                break;
              }
            }
            for (
              let a = 0;
              a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.length;
              a++
            ) {
              this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.key = a;
            }
          }
          for (let j = 0; j < this.podrForm.podr_prod_cut_list.length; j++) {
            if (
              Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
              this.podrForm.podr_prod_cut_list[j].prod_parent_value
            ) {
              this.podrForm.podr_prod_cut_list[j].prod_parent_value = [];
              this.podrForm.podr_prod_cut_list[j].prod_parent_ids = "";
            }
          }
          for (let j in this.plmtrlOption) {
            if (
              Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
              this.plmtrlOption[j].podr_prod_mtrl_id
            ) {
              this.plmtrlOption.splice(j, 1);
              break;
            }
          }
          for (let j in this.cutOption) {
            if (
              Number(this.plmtrlSelect[i].podr_prod_mtrl_id) ===
              this.cutOption[j].podr_prod_mtrl_id
            ) {
              this.cutOption.splice(j, 1);
              break;
            }
          }
        }
        // for(let i=0;i<this.podrForm.podr_prod_plmtrl_list.length;i++){
        //   this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption = JSON.parse(JSON.stringify(this.plmtrlOption))
        // }
        for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
          // this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(JSON.stringify(this.semiprodOption))
          if (this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.length === 0) {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids = "";
          } else if (
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.length === 1
          ) {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids =
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list[0].toString();
          } else {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids =
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.join(",");
          }
        }
        for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
          this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
            JSON.stringify(this.cutOption)
          );
        }
        temp = temp.sort((a, b) => {
          return b - a;
        });
        for (let j of temp) {
          this.podrForm.podr_prod_plmtrl_list.splice(j, 1);
        }
        setTimeout(() => {
          this.bomFlag = false;
          this.plmtrlFlag = false;
          this.cutFlag = false;
          this.semiprodFlag = false;
        }, 500);
      } else {
        this.$message({
          message: "至少选择一条信息",
          type: "warning",
        });
      }
    },
    // bom清单小窗口取消
    bomChildChanel() {
      this.dialogVisible = false;
    },
    falseBom() {
      this.bomChildChanel();
    },
    // bom清单小窗口确定
    childBom(val) {
      let bomImportVal = val;
      bomImportVal = bomImportVal.filter((item) =>
        this.podrForm.podr_prod_mtrl_list.every(
          (item1) => item.mtrl_id !== item1.mtrl_id
        )
      );
      for (let i of bomImportVal) {
        i.podr_prod_mtrl_id = this.bomProdMtrlId;
        this.bomProdMtrlId--;
      }
      for (let i = 0; i < bomImportVal.length; i++) {
        let item = {};
        item.podr_prod_mtrl_id = bomImportVal[i].podr_prod_mtrl_id;
        item.mtrl_no = bomImportVal[i].mtrl_no;
        if (bomImportVal[i].mtrl_type === 0) {
          this.plmtrlOption.push(item);
          this.cutOption.push(item);
          for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
            this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption.push(item);
          }
        } else {
          this.semiprodOption.push(item);
          for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
            this.podrForm.podr_prod_semiprod_list[i].semiprodOption.push(item);
          }
        }
      }
      for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
        this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
          JSON.stringify(this.cutOption)
        );
      }
      this.podrForm.podr_prod_mtrl_list =
        this.podrForm.podr_prod_mtrl_list.concat(bomImportVal);
      this.$refs.ProdEditBom.clear();
      this.dialogVisible = false;
    },
    //bom清单导入
    addRow() {
      this.dialogVisible = true;
    },
    //bom清单多选删除
    delBom() {
      let f = this.selectionsList.map((item) => {
        return item.podr_prod_mtrl_status == 1;
      });

      if (f.indexOf(true) != -1) {
        return this.$message.warning("已出库的不可以删除");
      }
      if (this.selectionsList.length > 0) {
        this.bomFlag = true;
        this.plmtrlFlag = true;
        this.cutFlag = true;
        this.semiprodFlag = true;
        let temp = [];
        for (let i = 0; i < this.selectionsList.length; i++) {
          let ind = null;
          ind = this.podrForm.podr_prod_mtrl_list.indexOf(this.selectionsList[i]);
          temp.push(ind);
          if (this.selectionsList[i].mtrl_type === 0) {
            for (let j = 0; j < this.podrForm.podr_prod_plmtrl_list.length; j++) {
              for (
                let a = 0;
                a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list.length;
                a++
              ) {
                if (
                  Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                  this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list[a]
                ) {
                  this.podrForm.podr_prod_plmtrl_list[j].prod_parent_list.splice(
                    a,
                    1
                  );
                  break;
                }
              }
              for (
                let a = 0;
                a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.length;
                a++
              ) {
                if (
                  Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                  this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO[a].podr_prod_mtrl_id
                ) {
                  this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.splice(
                    a,
                    1
                  );
                  break;
                }
              }
              for (
                let a = 0;
                a < this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption.length;
                a++
              ) {
                if (
                  Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                  this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption[a].podr_prod_mtrl_id
                ) {
                  this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption.splice(a, 1);
                  break;
                }
              }
              for (
                let a = 0;
                a < this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.length;
                a++
              ) {
                this.podrForm.podr_prod_plmtrl_list[j].prod_parent_listO.key = a;
              }
            }
            for (let j = 0; j < this.podrForm.podr_prod_cut_list.length; j++) {
              if (
                Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                this.podrForm.podr_prod_cut_list[j].prod_parent_value
              ) {
                this.podrForm.podr_prod_cut_list[j].prod_parent_value = [];
                this.podrForm.podr_prod_cut_list[j].prod_parent_ids = "";
              }
            }
            for (let j in this.plmtrlOption) {
              if (
                Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                this.plmtrlOption[j].podr_prod_mtrl_id
              ) {
                this.plmtrlOption.splice(j, 1);
                break;
              }
            }
            for (let j in this.cutOption) {
              if (
                Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                this.cutOption[j].podr_prod_mtrl_id
              ) {
                this.cutOption.splice(j, 1);
                break;
              }
            }
          } else {
            for (let j = 0; j < this.podrForm.podr_prod_semiprod_list.length; j++) {
              for (
                let a = 0;
                a < this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.length;
                a++
              ) {
                if (
                  Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                  this.podrForm.podr_prod_semiprod_list[j].prod_parent_list[a]
                ) {
                  this.podrForm.podr_prod_semiprod_list[j].prod_parent_list.splice(
                    a,
                    1
                  );
                  break;
                }
              }
              for (
                let a = 0;
                a < this.podrForm.podr_prod_semiprod_list[j].semiprodOption.length;
                a++
              ) {
                if (
                  Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                  this.podrForm.podr_prod_semiprod_list[j].semiprodOption[a]
                    .podr_prod_mtrl_id
                ) {
                  this.podrForm.podr_prod_semiprod_list[j].semiprodOption.splice(
                    a,
                    1
                  );
                  break;
                }
              }
            }
            for (let j in this.semiprodOption) {
              if (
                Number(this.selectionsList[i].podr_prod_mtrl_id) ===
                this.semiprodOption[j].podr_prod_mtrl_id
              ) {
                this.semiprodOption.splice(j, 1);
                break;
              }
            }
          }
        }
        for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
          // this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(JSON.stringify(this.semiprodOption))
          if (this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.length === 0) {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids = "";
          } else if (
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.length === 1
          ) {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids =
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list[0].toString();
          } else {
            this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids =
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.join(",");
          }
        }
        for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
          // this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(JSON.stringify(this.semiprodOption))
          if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 0
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids = "";
          } else if (
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.length === 1
          ) {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[
                i
              ].prod_parent_list[0].toString();
          } else {
            this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids =
              this.podrForm.podr_prod_semiprod_list[i].prod_parent_list.join(",");
          }
        }
        // for(let i=0;i<this.podrForm.podr_prod_plmtrl_list.length;i++){
        //   this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption = JSON.parse(JSON.stringify(this.plmtrlOption))
        // }
        for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
          this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
            JSON.stringify(this.cutOption)
          );
        }
        temp = temp.sort((a, b) => {
          return b - a;
        });
        for (let j of temp) {
          this.podrForm.podr_prod_mtrl_list.splice(j, 1);
        }
        setTimeout(() => {
          console.log('jieo',this.podrForm.podr_prod_plmtrl_list);
          this.bomFlag = false;
          this.plmtrlFlag = false;
          this.cutFlag = false;
          this.semiprodFlag = false;
        }, 500);
      } else {
        this.$message({
          message: "至少选择一条信息",
          type: "warning",
        });
      }
    },
    //bom清单选择框
    handleSelectionChange(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取委托人
    getStffType() {
      get(stffAPI.getAllStffsV1)
        .then((res) => {
          if (res.data.code === 0) {
            this.stffType = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = "error";
            this.$message({ message: mg, type: tp });
          }
        })
        .catch((res) => {
          let mg = res.data.msg;
          let tp = "error";
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取单位
    getMtrlType() {
      get(optnAPI.getAllContent, { perm_id: 10005 })
        .then((res) => {
          if (res.data.code === 0) {
            this.mtrlTypeGroupOpt = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = "error";
            this.$message({ message: mg, type: tp });
          }
        })
        .catch((res) => {
          let mg = res.data.msg;
          let tp = "error";
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取表单信息
    getprodInfo() {
      this.podrForm.podr_prod_id = this.$route.query.form_id;
      get(podtAPI.getPodtById, { podr_prod_id: this.podrForm.podr_prod_id })
        .then((res) => {
          if (res.data.code === 0) {
            this.bomFlag = true;
            this.plmtrlFlag = true;
            this.cutFlag = true;
            this.semiprodFlag = true;
            this.showPlmtrl = false;
            this.podrForm = res.data.data.form;
            this.btn = res.data.data.btn;
            let urlEng = JSON.parse(JSON.stringify(this.podrForm.imge_url));
            if (this.podrForm.imge_id) {
              this.dataBody.imge_id = this.podrForm.imge_id;
            } else {
              this.dataBody.imge_id = 0;
            }
            
            let updateTime = JSON.parse(JSON.stringify(new Date().getTime()))
            this.podrForm.imge_url = this.helper.picUrl(urlEng, "s",updateTime,this.podrForm.imge_source);
            this.podrForm.imge_urlO = this.helper.picUrl(urlEng, "l",updateTime,this.podrForm.imge_source);
            if (this.show) {
              this.podrForm.imge_id = this.imgForm.imge_id;
              this.podrForm.imge_url = this.imgForm.imge_url;
              this.podrForm.imge_urlO = this.imgForm.imge_urlO;
              this.show = false;
            }
            this.imgForm.imge_url = JSON.parse(
              JSON.stringify(this.podrForm.imge_url)
            );
            this.imgForm.imge_urlO = JSON.parse(
              JSON.stringify(this.podrForm.imge_urlO)
            );
            this.imgForm.imge_id = JSON.parse(
              JSON.stringify(this.podrForm.imge_id)
            );
            if (this.podrForm.prod_price !== null) {
              this.podrForm.prod_price = this.helper.haveFour(
                this.podrForm.prod_price
              );
            }
            if (this.podrForm.prod_verify_price !== null) {
              this.podrForm.prod_verify_price = this.helper.haveFour(
                this.podrForm.prod_verify_price
              );
            }
            if (this.podrForm.prod_freight !== null) {
              this.podrForm.prod_freight = this.helper.haveFour(
                this.podrForm.prod_freight
              );
            }
            if (this.podrForm.podr_prod_bag_l !== null) {
              this.podrForm.podr_prod_bag_l = this.helper.reservedDigits(
                this.podrForm.podr_prod_bag_l
              );
            }
            if (this.podrForm.podr_prod_bag_w !== null) {
              this.podrForm.podr_prod_bag_w = this.helper.reservedDigits(
                this.podrForm.podr_prod_bag_w
              );
            }
            if (this.podrForm.podr_prod_box_h !== null) {
              this.podrForm.podr_prod_box_h = this.helper.reservedDigits(
                this.podrForm.podr_prod_box_h
              );
            }
            if (this.podrForm.podr_prod_box_l !== null) {
              this.podrForm.podr_prod_box_l = this.helper.reservedDigits(
                this.podrForm.podr_prod_box_l
              );
            }
            if (this.podrForm.podr_prod_box_w !== null) {
              this.podrForm.podr_prod_box_w = this.helper.reservedDigits(
                this.podrForm.podr_prod_box_w
              );
            }
            if (this.podrForm.podr_prod_fill_weight !== null) {
              this.podrForm.podr_prod_fill_weight = this.helper.reservedDigits(
                this.podrForm.podr_prod_fill_weight
              );
            }
            if (this.podrForm.podr_prod_skin_weight !== null) {
              this.podrForm.podr_prod_skin_weight = this.helper.reservedDigits(
                this.podrForm.podr_prod_skin_weight
              );
            }
            if (this.podrForm.podr_prod_weight !== null) {
              this.podrForm.podr_prod_weight = this.helper.reservedDigits(
                this.podrForm.podr_prod_weight
              );
            }
            this.bomCopy = JSON.parse(
              JSON.stringify(this.podrForm.podr_prod_mtrl_list)
            );
            this.plmtrlCopy = JSON.parse(
              JSON.stringify(this.podrForm.podr_prod_plmtrl_list)
            );
            this.cutCopy = JSON.parse(
              JSON.stringify(this.podrForm.podr_prod_cut_list)
            );
            this.semiprodCopy = JSON.parse(
              JSON.stringify(this.podrForm.podr_prod_semiprod_list)
            );
            for (let i = 0; i < this.podrForm.podr_prod_mtrl_list.length; i++) {
              let item = {};
              item.podr_prod_mtrl_id = this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_id;
              item.mtrl_no = this.podrForm.podr_prod_mtrl_list[i].mtrl_no;
              if (this.podrForm.podr_prod_mtrl_list[i].mtrl_type === 0) {
                this.plmtrlOption.push(item);
                this.cutOption.push(item);
              } else {
                this.semiprodOption.push(item);
              }
              if (this.podrForm.podr_prod_mtrl_list[i].mtrl_prod_price !== null) {
                this.podrForm.podr_prod_mtrl_list[i].mtrl_prod_price =
                  this.helper.haveFour(
                    this.podrForm.podr_prod_mtrl_list[i].mtrl_prod_price
                  );
              }
              if (this.podrForm.podr_prod_mtrl_list[i].mtrl_width !== null) {
                this.podrForm.podr_prod_mtrl_list[i].mtrl_width =
                  this.helper.haveFour(
                    this.podrForm.podr_prod_mtrl_list[i].mtrl_width
                  );
              }
              if (this.podrForm.podr_prod_mtrl_list[i].mtrl_thick !== null) {
                this.podrForm.podr_prod_mtrl_list[i].mtrl_thick =
                  this.helper.haveFour(
                    this.podrForm.podr_prod_mtrl_list[i].mtrl_thick
                  );
              }
              if (this.podrForm.podr_prod_mtrl_list[i].mtrl_weight !== null) {
                this.podrForm.podr_prod_mtrl_list[i].mtrl_weight =
                  this.helper.reservedDigits(
                    this.podrForm.podr_prod_mtrl_list[i].mtrl_weight
                  );
              }
              if (this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_length !== null) {
                this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_length =
                  this.helper.reservedDigits(
                    this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_length
                  );
              }
              if (this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_width !== null) {
                this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_width =
                  this.helper.reservedDigits(
                    this.podrForm.podr_prod_mtrl_list[i].podr_prod_mtrl_width
                  );
              }
            }
            for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
              this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption = JSON.parse(
                JSON.stringify(this.plmtrlOption)
              );
            }
            for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list = [];
              if (
                this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids.indexOf(
                  ","
                ) >= 0
              ) {
                let arr =
                  this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids.split(",");
                for (let j in arr) {
                  arr[j] = Number(arr[j]);
                }
                this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list = arr;
              } else {
                let arr =
                  this.podrForm.podr_prod_plmtrl_list[i].prod_parent_ids.split(" ");
                for (let j in arr) {
                  arr[j] = Number(arr[j]);
                }
                this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list = arr;
              }
              let item = {};
              item.podr_prod_mtrl_id =
                this.podrForm.podr_prod_plmtrl_list[i].podr_prod_mtrl_id;
              item.mtrl_no = this.podrForm.podr_prod_plmtrl_list[i].mtrl_no;
              this.plmtrlOption.push(item);
              this.cutOption.push(item);
              if (this.podrForm.podr_prod_plmtrl_list[i].mtrl_prod_price !== null) {
                this.podrForm.podr_prod_plmtrl_list[i].mtrl_prod_price =
                  this.helper.haveFour(
                    this.podrForm.podr_prod_plmtrl_list[i].mtrl_prod_price
                  );
              }
              for (
                let j = i + 1;
                j < this.podrForm.podr_prod_plmtrl_list.length;
                j++
              ) {
                this.podrForm.podr_prod_plmtrl_list[j].plmtrlOption.push(
                  JSON.parse(JSON.stringify(item))
                );
              }
            }
            for (let i = 0; i < this.podrForm.podr_prod_plmtrl_list.length; i++) {
              this.podrForm.podr_prod_plmtrl_list[i].prod_parent_listO = [];
              for(let j=0;j<this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list.length;j++){
                let temp = this.podrForm.podr_prod_plmtrl_list[i].plmtrlOption.filter(item=>{return item.podr_prod_mtrl_id === this.podrForm.podr_prod_plmtrl_list[i].prod_parent_list[j]})
                
                if(temp[0]){
                  temp[0].key = JSON.parse(JSON.stringify(j))
                  this.podrForm.podr_prod_plmtrl_list[i].prod_parent_listO.push(JSON.parse(JSON.stringify(temp[0])))
                }
              }
            }
            for (let i = 0; i < this.podrForm.podr_prod_cut_list.length; i++) {
              let item = {};
              item.podr_prod_mtrl_id = this.podrForm.podr_prod_cut_list[i].podr_prod_mtrl_id;
              item.mtrl_no = JSON.parse(
                JSON.stringify(this.podrForm.podr_prod_cut_list[i].mtrl_no)
              );
              this.semiprodOption.push(item);
              this.podrForm.podr_prod_cut_list[i].prod_parent_value = Number(
                this.podrForm.podr_prod_cut_list[i].prod_parent_ids
              );
              this.podrForm.podr_prod_cut_list[i].cutOption = JSON.parse(
                JSON.stringify(this.cutOption)
              );
              this.podrForm.podr_prod_cut_list[i].mtrl_no =
                this.podrForm.podr_prod_cut_list[i].mtrl_no.substr(
                  this.podrForm.podr_prod_cut_list[i].mtrl_no.indexOf("@") + 1,
                  this.podrForm.podr_prod_cut_list[i].mtrl_no.length
                );
            }
            for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
              this.podrForm.podr_prod_semiprod_list[i].semiprodOption = JSON.parse(
                JSON.stringify(this.semiprodOption)
              );
            }
            for (let i = 0; i < this.podrForm.podr_prod_semiprod_list.length; i++) {
              this.podrForm.podr_prod_semiprod_list[i].prod_parent_list = [];
              if (
                this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids.indexOf(
                  ","
                ) >= 0
              ) {
                let arr =
                  this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids.split(
                    ","
                  );
                for (let j in arr) {
                  arr[j] = Number(arr[j]);
                }
                this.podrForm.podr_prod_semiprod_list[i].prod_parent_list = arr;
              } else {
                let arr =
                  this.podrForm.podr_prod_semiprod_list[i].prod_parent_ids.split(
                    " "
                  );
                for (let j in arr) {
                  arr[j] = Number(arr[j]);
                }
                this.podrForm.podr_prod_semiprod_list[i].prod_parent_list = arr;
              }
              let item = {};
              item.podr_prod_mtrl_id =
                this.podrForm.podr_prod_semiprod_list[i].podr_prod_mtrl_id;
              item.mtrl_no = this.podrForm.podr_prod_semiprod_list[i].mtrl_no;
              for (
                let j = i + 1;
                j < this.podrForm.podr_prod_semiprod_list.length;
                j++
              ) {
                this.podrForm.podr_prod_semiprod_list[j].semiprodOption.push(
                  JSON.parse(JSON.stringify(item))
                );
              }
              this.semiprodOption.push(JSON.parse(JSON.stringify(item)));
              this.podrForm.podr_prod_semiprod_list[i].mtrl_no =
                this.podrForm.podr_prod_semiprod_list[i].mtrl_no.substr(
                  this.podrForm.podr_prod_semiprod_list[i].mtrl_no.indexOf("#") + 1,
                  this.podrForm.podr_prod_semiprod_list[i].mtrl_no.length
                );
            }
            this.getInputUser();
            setTimeout(() => {
              this.bomFlag = false;
              this.plmtrlFlag = false;
              this.cutFlag = false;
              this.semiprodFlag = false;
            }, 1000);
            setTimeout(() => {
              this.showPlmtrl = true;
              this.loadingFlag = false;
            }, 1000);
          } else {
            let mg = res.data.msg;
            let tp = "error";
            this.$message({ message: mg, type: tp });
          }
        })
        .catch((res) => {
          let mg = res.data.msg;
          let tp = "error";
          this.$message({ message: mg, type: tp });
        });
    },
    //获取录入人
    getInputUser() {
      this.stffForm.cptt_id = this.podrForm.cptt_id;
      this.stffForm.user_id = this.podrForm.user_id;
      this.stffForm.dept_id = this.podrForm.dept_id;
      this.stffForm.stff_id = this.podrForm.stff_id;
      this.stffForm.cptt_abbr = this.podrForm.cptt_abbr;
      this.stffForm.dept_name = this.podrForm.dept_name;
      this.stffForm.dept_team_id = this.podrForm.dept_team_id;
      this.stffForm.dept_team_name = this.podrForm.dept_team_name;
      this.stffForm.stff_name = this.podrForm.stff_name;
    },
  },
};
</script>

<style scoped lang="scss">
.vd_bortop {
  border-top: #dcdfe6 solid 1px;
  padding-top: 20px;
}
.vd_eltab {
  margin-top: 10px;
}
.vd_buttom {
  padding-bottom: 32px;
}
.vd_but {
  margin-bottom: 10px;
}
.vd_ml10 {
  margin-left: 10px;
}
.vd_dis {
  display: inline-block;
}
.vd_mrl {
  margin-left: 5px;
}
.vd_bortop {
  border-top: #dcdfe6 solid 1px;
  padding-top: 20px;
}
.vd_edhea {
  position: relative;
  margin-bottom: 20px;
}
.vd_export {
  position: absolute;
  top: 0;
  left: 65px;
}
.vd_exports {
  position: absolute;
  top: 0;
  left: 120px;
}
.vd_mrb {
  margin-bottom: 1px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader ::v-deep .el-upload--text {
  width: 136px;
  height: 136px;
}
.avatar-uploader .el-upload:hover {
  border-color: $color-primary;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: $color-uploader-icon;
  width: 136px;
  height: 136px;
  line-height: 136px;
  text-align: center;
}
.avatar {
  width: 136px;
  height: 136px;
  display: block;
}
.vd_cussor {
  cursor: default;
}
.vd_draw{
  padding: 20% 10%;
}
::v-deep .el-upload--text{
  border: 1px dashed #d9d9d9 !important;
}
</style>
